import React from "react"
import { Link } from "gatsby"
import { BsChevronRight } from "react-icons/bs"

export default function BreadCrumbs({ breadCrumbs, className }) {
  return (
    <div
      className={`text-xs text-slate-400 capitalize ${className}`}
      itemScope
      itemType="https://schema.org/BreadcrumbList"
    >
      {breadCrumbs.map((breadCrumb, index) =>
        !breadCrumb.active ? (
          <span
            key={breadCrumb.url}
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <Link
              itemProp="item"
              to={breadCrumb.url}
              className="underline inline-block"
            >
              <span itemProp="name">{breadCrumb.name}</span>
            </Link>
            <meta itemProp="position" content={index + 1} />
            <BsChevronRight className="mx-2 inline-block" />
          </span>
        ) : (
          <div
            key={breadCrumb.url}
            className="inline-block"
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <span itemProp="name">{breadCrumb.name}</span>
            <meta itemProp="position" content={index + 1} />
          </div>
        )
      )}
    </div>
  )
}
